<template>
  <div class="home">

    <!-- =======Intro====== -->
    <section id="intro">
      <div class="wrapper">
        <div class="intro-head">
          <span class="text_up">Inquisitive</span>
          <span class="text_up">creative</span>
          <span class="text_up">explorer</span>
          <p class="intro-p fade_simple">
            Building slowly, learning always.
            Exploring ideas, one click at a time.
            Making small things with care.
          </p>
        </div>
        <img src="@/assets/img/scrolltext.svg" alt="Scroll Down" class="circle__text">
      </div>
    </section>

    <!-- ========About======= -->
    <section id="short-about">
      <div class="about-head">
        <div class="circle-photo fade_simple"><img src="@/assets/img/me.webp" alt="Farhan"></div>
        <a href="#" class="btn-cir">More <br> About Me</a>
      </div>
      <div class="about-text fade_fast">
        <p class="para">
          I'm Farhan, a frontend and WordPress developer with a focus on building user-first websites that combine function 
          with aesthetic clarity. <br><br>I specialize in frontend development, Elementor-based WordPress sites, eCommerce solutions, 
          and business websites. With a strong creative sense and a sharp eye for design, I craft clean, responsive interfaces 
          that engage users and support your goals. <br><br>
          I’m always open to collaborating on impactful projects that value thoughtful design and purposeful user experience.

        </p>
      </div>
    </section>

    <!-- =========Projects======== -->
    <section id="projects">
      <h1 class="headline">Feel free to browse through a few of my <span class="highlight fade">works</span> below.</h1>

      <div class="wrapper">
        <ProjectCard class="opacity_hide" v-for="(pro, i) in projects.slice(0, 3)" :pro="pro" :key="pro.id" :index="i" />
      </div>
    </section>

  </div>
</template>

<script>
import ProjectCard from "@/components/ProjectCard.vue"

//Animations
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import SplitType from 'split-type'
//========

export default {
  props: ["projects"],
  components: {
    ProjectCard
  },
  mounted() {
    this.animate()

  },
  methods: {
    animate() {
      const opacity = document.querySelectorAll('.opacity_hide')
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          entry.target.classList.toggle('opacity_show', entry.isIntersecting)
        });
      },{
        threshold:.3
      })
      opacity.forEach(el=>{
        observer.observe(el)
      })
      
      const fadeSimple = document.querySelectorAll('.fade_simple')
      fadeSimple.forEach(el => {
        gsap.fromTo(el, {
          opacity: 0
        },
          {
            scrollTrigger: {
              trigger: el,
              start: 'top 95%',
              end:'top 5%'
            },
            opacity: 1,
            delay: .2,
            duration: 1.2
          })
      })
      const textUp = document.querySelectorAll('.text_up') //1
      textUp.forEach(word => {
        const text = new SplitType(word, { types: 'chars, words' })

        gsap.fromTo(text.chars, {
          y: '100px'
        },
          {
            scrollTrigger: {
              trigger: word,
              start: 'top 95%'
            },
            y: 0,
            stagger: .01,
            delay: .3,
            ease: 'power4.out',
            duration: 1.2
          })
      })
      const fade = document.querySelectorAll('.fade') //2
      fade.forEach(word => {
        const text = new SplitType(word, { types: 'words' })

        gsap.fromTo(text.words, {
          opacity: 0
        },
          {
            scrollTrigger: {
              trigger: word,
              start: 'top 95%',
              end:'top 5%'
            },
            opacity: 1,
            stagger: .1,
            delay: .2
          })
      })
      const fadeFast = document.querySelectorAll('.fade_fast') //3
      fadeFast.forEach(word => {
        const text = new SplitType(word, { types: 'words' })

        gsap.fromTo(text.words, {
          opacity: 0
        },
          {
            scrollTrigger: {
              trigger: word,
              start: 'top 95%',
              end:'top 5%'
            },
            opacity: 1,
            stagger: .04,
            delay: .2
          })
      })
      const fadeLeft = document.querySelectorAll('.fade_left') //4

      fadeLeft.forEach(word => {
        const text = new SplitType(word, { types: 'words' })

        gsap.fromTo(text.words, {
          opacity: 0,
          x: -20
        },
          {
            scrollTrigger: {
              trigger: word,
              start: 'top 95%',
              end:'top 5%'
            },
            opacity: 1,
            x: 0,
            stagger: .05,
            delay: .2
          })
      })
      ////
    }
  }
}
</script>


 